/* eslint-disable react/display-name */
import React from "react";

export const HeaderOne = React.forwardRef(({ attributes, style, children }, ref) => (
  <h1
    ref={ref}
    css={{
      fontSize: 40,
      color: "#086be5",
      fontWeight: 700,
    }}
    style={style}
    {...attributes}
  >
    {children}
  </h1>
));

export const HeaderTwo = React.forwardRef(({ attributes, style, children }, ref) => (
  <h2
    ref={ref}
    css={{
      fontSize: 32,
      color: "#20252d",
      fontWeight: 600,
    }}
    style={style}
    {...attributes}
  >
    {children}
  </h2>
));

export const HeaderThree = React.forwardRef(({ attributes, style, children }, ref) => (
  <h3
    ref={ref}
    css={{
      fontSize: 32,
      lineHeight: "34px",
      color: "#20252d",
      fontWeight: 600,
      marginTop: "50px",
    }}
    style={style}
    {...attributes}
  >
    {children}
  </h3>
));

export const HeaderFour = React.forwardRef(({ attributes, style, children }, ref) => (
  <h4
    ref={ref}
    css={{
      fontSize: 24,
      lineHeight: "34px",
      color: "#20252d",
      fontWeight: 700,
      marginTop: "50px",
    }}
    style={style}
    {...attributes}
  >
    {children}
  </h4>
));
